import * as React from 'react';

import '@app/scss/valueInclusive/index.scss';

interface OwnProps {
	icon: string;
	header: string;
	text: string;
}

export const Bullet: React.FC<OwnProps> = (props: OwnProps) => {
	return (
		<div className="bullet-container">
			<div className="bullet-container__icon">
				<img
					src={props.icon}
					alt={props.header}
				/>
			</div>

			<div>
				<h4 className="text-size_large">
					{props.header}
				</h4>
				<span className="text-size_small font-weight_light">
					{props.text}
				</span>
			</div>
		</div>
	);
};
